import { type HydratedViewColumnDefs } from "./useHydratedColumnDefs";

export function chooseNewColumnHeader(columnDefs: HydratedViewColumnDefs): string {
	const existingHeaders = new Set(columnDefs.allColumns.map((column) => column.header));

	let counter = 1;
	let newHeader = `Column ${counter}`;

	while (existingHeaders.has(newHeader)) {
		newHeader = `Column ${counter}`;
		counter++;
	}

	return newHeader;
}

export function existingAccessorKeys(columnDefs: HydratedViewColumnDefs): Set<string> {
	return new Set<string>(columnDefs.allColumns.map((column) => column.accessorKey));
}

export function headerToAccessorKey(input: string, existingKeys: Set<string>): string {
	const formattedString = input.toLowerCase().trim().replace(/\s+/g, "_");
	let uniqueString = formattedString;
	let counter = 1;

	while (existingKeys.has(uniqueString)) {
		uniqueString = `${formattedString}${counter}`;
		counter++;
	}

	return uniqueString;
}
